/**
 * "The widget" overview & embedding — Widget section (ADR-0074).
 * Reconciled from apps/widget (entry, bootstrap, embed snippet).
 */
import type { DocPageContent } from '../types';

const SCRIPT = `<script
  type="module"
  src="https://cdn.syncanix.com/widget.js"
  data-key="pk_live_..."
  data-position="bottom-right"
></script>`;

export const WIDGET_OVERVIEW_PAGE: DocPageContent = {
  slug: 'widget',
  titleKey: 'docs.widget.overview.title',
  descriptionKey: 'docs.widget.overview.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.widget.overview.lead' },

    { kind: 'heading', level: 2, id: 'embed', textKey: 'docs.widget.overview.embed.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.overview.embed.body' },
    { kind: 'code', language: 'html', code: SCRIPT },
    { kind: 'paragraph', textKey: 'docs.widget.overview.embed.note' },
    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.widget.overview.embed.guide.title',
      textKey: 'docs.widget.overview.embed.guide.body',
      links: {
        embedding: {
          target: { docSlug: 'widget/embedding' },
          labelKey: 'docs.widget.overview.embed.guide.link',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'how', textKey: 'docs.widget.overview.how.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.overview.how.body' },

    { kind: 'heading', level: 2, id: 'safe', textKey: 'docs.widget.overview.safe.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.overview.safe.body' },

    { kind: 'heading', level: 2, id: 'boundary', textKey: 'docs.widget.overview.boundary.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.overview.boundary.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.widget.overview.boundary.item.isolated',
        'docs.widget.overview.boundary.item.noRead',
        'docs.widget.overview.boundary.item.key',
        'docs.widget.overview.boundary.item.user',
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.widget.overview.boundary.note.title',
      textKey: 'docs.widget.overview.boundary.note.body',
      links: {
        boundaries: {
          target: { docSlug: 'boundaries' },
          labelKey: 'docs.widget.overview.boundary.note.link',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.widget.overview.next.config.title',
          textKey: 'docs.widget.overview.next.config.text',
          to: { docSlug: 'widget/configuration' },
        },
        {
          titleKey: 'docs.widget.overview.next.theming.title',
          textKey: 'docs.widget.overview.next.theming.text',
          to: { docSlug: 'widget/theming' },
        },
      ],
    },
  ],
};
